import React from "react";
import "./section.scss";

function BanerSubTitle() {
  return (
    <div className="section__baner-sub">
      <h1 className="section__baner-sub_h1">
        <span className="section__baner-sub_span">PHOTOGRAPHY</span>
      </h1>
    </div>
  );
}

export default BanerSubTitle;
